// extracted by mini-css-extract-plugin
module.exports = {"outer":"_1sdHG","heading":"_2c_5v","subHeading":"_3Od30"};